// Dual-runtime environment access.
//
// In the browser/Vite build, `import.meta.env` is statically provided by Vite.
// In the Node prerender step (run via tsx), `import.meta.env` is undefined and
// the same values arrive through `process.env`. This reader works in both without
// asserting shapes: it reads the typed sources and narrows with `typeof`.

function readEnv(key: string): string | undefined {
  const fromVite = import.meta.env?.[key];
  if (typeof fromVite === "string") {
    return fromVite;
  }

  if (typeof process !== "undefined" && process.env) {
    const fromNode = process.env[key];
    if (typeof fromNode === "string") {
      return fromNode;
    }
  }

  return undefined;
}

/** Configured asset base path (Vite `base`), e.g. "/" or "/foxmark/". */
export function baseUrl(): string {
  return readEnv("BASE_URL") || readEnv("VITE_BASE_PATH") || "/";
}

/** Read a `VITE_`-prefixed variable, falling back to `fallback` when unset. */
export function viteVar(key: string, fallback: string): string {
  return readEnv(key) || fallback;
}
